import React from 'react'
import _ from 'lodash'
import AuthDialog from 'src/common/razzle-platform-user/Authentication/AuthDialog'
import {AuthenticationContext, useAuth, useAuthDialog, IAuthenticationContext} from 'src/common/razzle-platform-user/Authentication/hooks'

function AuthenticationProvider({children, ...props}) {
    const auth = useAuthDialog()
    const contextValue = _.pick(auth, [
        'isAuthenticationDialogOpen', 'displayLogin', 'displayRegister', 'displayAuthorization', 'onAuth',
        'closeAuthenticationDialog', 'actions', 'isAuthenticated'
    ])

    return(
        <AuthenticationContext.Provider value={contextValue as IAuthenticationContext}>
            {children}
            <AuthDialog {...props} />
        </AuthenticationContext.Provider>
    )
}


export {
    AuthenticationProvider,
    useAuth
}
